import React, { useRef } from "react";
import NumberInput, { type Props as NumberInputProps, type NumericValue } from "components/NumberInput";
import { useValidate } from "formvalidation/hooks";

interface Props extends Omit<NumberInputProps, "onChanged" | "onBlur" | "error" | "onEnterPressed" | "onEscPressed"> {
  autoFocus?: boolean
  onChange: (newValue: number) => void
  onEnterPressed?: (newValue: number) => void
  onEscPressed?: () => void
  validatorKey: string
}

const RequiredNumberInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { onChange, validatorKey, onEnterPressed, onEscPressed, ...rest } = props;

  const validate = async (input: number | string) => {
    if (input == null || input === "") {
      return false;
    }

    const number = Number(input);
    const isValid = !Number.isNaN(number) && number !== 0;

    return isValid;
  };

  const validation = useValidate({
    key: validatorKey,
    title: validatorKey,
    value: props.value,
    validate: validate,
    ref: inputRef,
  })

  const onChanged = async (newValue: NumericValue) => {
    props.onChange(newValue.value);
  };

  return <NumberInput
    {...rest}
    innerRef={inputRef}
    error={validation.error.hasError}
    onEnterPressed={(v) => onEnterPressed?.(v.value)}
    onEscPressed={onEscPressed}
    onChanged={onChanged}
    focusOnMount={props.autoFocus}
  />;
};

export default RequiredNumberInput;
